import { SelectButton, Calendar, Dropdown, addLocale } from 'primereact';
import React, {useEffect, useState} from 'react';

export const GraficosCxc = () => {
    const [value, setValue] = React.useState(null);
            const periodosPredifinidos = [
                { name: 'Diario', value: 1 },
                { name: 'Semanal', value: 2 },
                { name: 'Mensual', value: 3 },
                { name: 'Trimestral', value: 4 },
                { name: 'Anual', value: 5 }
                ];
            function handleChange(value) {
                setValue(value);
                switch (value) {
                    case 1:
                    v_periodo = 'diario'
                    llenarGraficos('diario')
                    break;
                    case 2:
                    v_periodo = 'semanal'
                    llenarGraficos('semanal')
                    break;
                    case 3:
                    v_periodo = 'mensual'
                    llenarGraficos('mensual')
                    break;
                    case 4:
                    v_periodo = 'trimestral'
                    llenarGraficos('trimestral')
                    break;
                    case 5:
                    v_periodo = 'anual'
                    llenarGraficos('anual')
                    break;
                }
            }
          React.useEffect(() => {
                v_periodo = 'mensual';
                llenarGraficos('mensual');
          }, [])
    React.useEffect(() => {
        if(localStorage.getItem('periodoGrafico')){
            setValue(JSON.parse(localStorage.getItem('periodoGrafico')))
        }else {
            setValue(3);
        }
    }, [])
    return (
        <React.Fragment> 
            <div>
                <div 
                    style={{    
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '10px',
                        padding: '12px',
                        flexWrap: 'wrap',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}
                > 
                    <SelectButton 
                        value={value}
                        onChange={(e) => handleChange(e.value)}
                        optionLabel='name'
                        options= {periodosPredifinidos}
                     />    
                </div>
            </div>
        </React.Fragment>
        );
}
